import { Typography } from "@/components/common/Typography/Typography"
import {
  TranslationKeys,
  useTranslation,
} from "@/hooks/useTranslation/useTranslation"
import { QuestionListFilter } from "@/pages/questionnaire/QuestionListFilter"
import { ResponseFilter } from "@/pages/questionnaire/useQuestionListFilters"
import { ReactNode } from "react"

interface SplitViewQuestionHeaderProps {
  titleKey?: TranslationKeys
  countLabelKey: TranslationKeys
  countValueDisplay: ReactNode
  className?: string
  activeFilter?: ResponseFilter
  filterCounts?: Record<ResponseFilter, number>
  setActiveFilter?: (filter: ResponseFilter) => void
}

export const SplitViewQuestionHeader = ({
  titleKey,
  countLabelKey,
  countValueDisplay,
  className = "",
  activeFilter,
  filterCounts,
  setActiveFilter,
}: SplitViewQuestionHeaderProps) => {
  const { translate } = useTranslation()

  return (
    <div
      className={`flex items-center justify-between border-b border-grey4 py-XS ${className}`}
      id={"total-questions-answers"}
    >
      {titleKey ? (
        <div className={`flex items-center justify-between ${className}`}>
          <Typography as="h2" variant="titleM">
            {translate(titleKey)}
          </Typography>
        </div>
      ) : (
        <>
          {activeFilter !== undefined && filterCounts && setActiveFilter && (
            <QuestionListFilter
              activeFilter={activeFilter}
              filterCounts={filterCounts}
              onFilterChange={setActiveFilter}
            />
          )}
        </>
      )}

      <Typography as="p" variant="textM">
        {translate(countLabelKey)} {countValueDisplay}
      </Typography>
    </div>
  )
}
